import { getItem } from '@/utils/storage'

export const useShowCommunity = () => {
    const isShowTip = getItem('isShowCommunityTip')
    return !isShowTip;
}
